import { useMutation } from '@tanstack/react-query';
import Api from '../api/Api';

export const useOverlayGeojsonMutation = () =>
  useMutation({
    mutationFn: async ({
      id,
      level1,
      level2,
      color,
    }: {
      id: string;
      level1: string;
      level2: string;
      color: string;
    }) => {
      return await Api.fileEndPoint.getOverlayGeoJson(
        id,
        level1,
        level2,
        color
      );
    },
  });
